module.exports = __webpack_public_path__ + "static/media/main-logo.a29b6a6d.svg";